import React, { Component } from 'react'
import styles from "./GSearch.module.css"

import CropImageContainer from "./CropImageContainer"
import { PostToContent, registerCB } from "../util/Comm"

import DEFAULT_SRC from "../static/icon-Oolet.png"

export default class GSearch extends Component {
    constructor(props) {
        super(props)

        this.state = {
            defaultImgSrc: DEFAULT_SRC,
            searchImgSrc: DEFAULT_SRC,
            searchType: "",
            cropTop: 0,
            cropLeft: 0,
        }
    }

    // handler
    cropCompleteCallback = (img, crop) => {
        console.log(crop)
        this.setState(state => {
            return {
                searchImgSrc: img,
                cropTop: crop.y,
                cropLeft: crop.x,
            }
        })
    }

    searchImgHandler = (e) => {
        PostToContent({ type: "SEARCH_IMG_SRC_REQ", imgSrc: this.state.searchImgSrc })
    }
    //callback
    getImgCallback = (data) => {
        if (data.imgSrc != "") {
            this.setState(state => {
                return {
                    defaultImgSrc: data.imgSrc,
                    searchImgSrc: data.imgSrc,
                    searchType: data.searchType
                }
            })
        }
    }
    // sub-component
    searchHovering = () => {
        return (
            <div className={styles.imgWrapper} onClick={this.searchImgHandler}>
                <img src={this.state.searchImgSrc} alt="" srcset="" />
            </div>
        )
    }
    cropImageComp = () => {
        const searchStyle = {
            position: "absolute",
            top: `${this.state.cropTop}px`,
            left: `${this.state.cropLeft}px`,
        }
        return (
            <div className={styles.cropWrapper}>
                <CropImageContainer cropCompleteCallback={this.cropCompleteCallback} imgSrc={this.state.defaultImgSrc} />
                <div className={styles.searchBtnStyle} style={searchStyle} onClick={this.searchImgHandler}>Search</div>
            </div>
        )
    }
    componentDidMount() {
        registerCB({ type: "SEARCH_IMG_SRC_FROM_EXTENSION", callback: this.getImgCallback })
    }

    render() {
        var searchComp = this.searchHovering()
        if (this.state.searchType == "CROP")
            searchComp = this.cropImageComp()

        return (
            <div className={styles.container}>
                {searchComp}
            </div>
        )
    }
}

// step1: get img from extension
// PostToContent({ type: "GET_SEARCH_IMG_SRC_REQ" })
// step2: after get img send request for search
// PostToContent({ type: "SEARCH_IMG_SRC_REQ", imgSrc: this.state.searchImgSrc })